import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=80324a20"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports